module.exports = __webpack_public_path__ + "img/10.917a0847.png";